import { DebounceInput } from 'react-debounce-input';

import { DEFAULTS } from 'constants/defaults.constant';

import CrossIcon from 'assets/events/icons/cross-icon.svg';
import SearchIcon from 'assets/icons/search-icon.svg';

import { CustomGlassBox } from './CustomGlassBox';

type SearchInputProps = {
  value: string;
  onChange: (value: string) => void;
};

export const SearchInput = ({ value, onChange }: SearchInputProps) => {
  const hasValue = value.length > 0;

  const handleClear = () => {
    onChange('');
  };

  return (
    <CustomGlassBox
      wrapperClassName="tw-w-full"
      className="tw-flex tw-h-[50px] tw-flex-1 tw-items-center tw-px-[20px] tw-py-[10px] lg:tw-max-w-[420px]"
    >
      <DebounceInput
        type="text"
        placeholder="Search..."
        value={value}
        debounceTimeout={DEFAULTS.defaultSearchDebounceTime}
        onChange={(e) => onChange(e.target.value)}
        className="tw-h-full tw-w-full tw-border-none tw-bg-transparent tw-font-jost tw-text-[16px] tw-leading-[12.2px] tw-text-white tw-placeholder-white tw-outline-none"
      />
      {hasValue ? (
        <img src={CrossIcon} alt="Clear search" className="tw-h-4 tw-w-4 tw-cursor-pointer" onClick={handleClear} />
      ) : (
        <img src={SearchIcon} alt="Search" className="tw-h-5 tw-w-5" />
      )}
    </CustomGlassBox>
  );
};
